import css from './resources.module.scss';

import cx from 'classnames';
import { memo } from 'react';

import { ImageResource } from 'com/ImageResource';

type Props = {
  resourceUids: string[];
};

export default memo(function Resources({ resourceUids }: Props) {
  return (
    <div className={cx(css.resources, resourceUids.length > 1 && css.multiple)}>
      {resourceUids.map(resourceUid => (
        <ImageResource
          key={resourceUid}
          className={css.image}
          resourceUid={resourceUid}
        />
      ))}
    </div>
  );
});
